<!-- 技术需求池 -->
<template>
  <div class="development">
    <div class="banner">
      <div class="content">
        <div class="search">
          <input
            type="text"
            v-model="keyword"
            placeholder="请输入关键词"
            @keyup.enter="handleSearch"
          />
          <button @click="handleSearch">
            <img src="../assets/search_icon.png" alt="" />搜索
          </button>
        </div>
      </div>
    </div>

    <div class="main">
      <div class="content">
        <div class="main_box">
          <div class="header">
            <div class="result">
              <p>搜索结果：</p>
              共有
              <p>{{ total }}</p>
              个结果
            </div>
            <div class="reset" @click="handleReset">
              <i class="el-icon-refresh-right"></i>
              <p>重置搜索</p>
            </div>
          </div>
          <div class="table" v-loading="loading">
            <table>
              <thead>
                <tr>
                  <th style="width: 25%">求购专利详情</th>
                  <th>联系人</th>
                  <th>联系方式</th>
                  <th>发布时间</th>
                  <th style="width: 15%">QQ</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in tableData" :key="item.id">
                  <td style="width: 25%">{{ item.description }}</td>
                  <td>{{ item.user?.contact || "-" }}</td>
                  <td>{{ item.user?.tel || "-" }}</td>
                  <td>{{ item.create_time }}</td>
                  <td style="width: 15%">{{ item.user?.qq || "-" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="paging">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pageSize"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getWantToBuy } from "../api/userApi";
export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      keyword: "",
      tableData: [],
    };
  },
  created() {
    this.getWantToBuyData();
  },
  methods: {
    async getWantToBuyData() {
      this.loading = true;
      try {
        const params = {
          page: this.page,
          limit: this.pageSize,
        };

        if (this.keyword) {
          params.keyword = this.keyword; // 注意：接口要求keyword是数组
        }

        const response = await getWantToBuy(params);
        if (response.code === 1) {
          this.tableData = response.data;
          this.total = response.count;
        }
      } catch (error) {
        console.error("获取技术需求数据失败:", error);
      } finally {
        this.loading = false;
      }
    },

    handleSearch() {
      this.page = 1;
      this.getWantToBuyData();
    },

    handleReset() {
      this.keyword = "";
      this.page = 1;
      this.getWantToBuyData();
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getWantToBuyData();
    },

    handleCurrentChange(val) {
      this.page = val;
      this.getWantToBuyData();
    },
  },
};
</script>

<style scoped lang="less">
.content {
  width: 100%;
  max-width: 87.5rem;
  margin: 0 auto;
  //   position: absolute;
}
.banner {
  //   position: relative;
  background: url(../assets/banner2.png) no-repeat center/cover;
  width: 100%;
  height: 318px;
  .content {
    width: 100%;
    max-width: 87.5rem;
    margin: 0 auto;
    position: relative;
  }
  .search {
    padding-top: 134px;
    display: flex;
    align-items: center;
    justify-content: center;
    input {
      width: 638px;
      height: 50px;
      background: #ffffff;
      border-radius: 9px 0px 0px 9px;
      border: none; /* 移除边框 */
      outline: none;
      padding-left: 25px;
    }
    input::placeholder {
      //   padding-left: 25px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #a9a9a9;
      font-style: normal;
    }
    input:focus {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #121212;
      font-style: normal;
    }
    button {
      cursor: pointer;
      border: none;
      outline: none;
      width: 96px;
      height: 50px;
      background: #c5e1ff;
      border-radius: 0px 9px 9px 0px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #175dc2;
      line-height: 20px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        margin-right: 3px;
      }
    }
  }
}
.main {
  background: #f5f5f5;
  padding-top: 20px;
  padding-bottom: 45px;
  width: 100%;
  .main_box {
    width: 100%;
    // height: 1017px;
    background: #fff;
    border-radius: 10px;
    padding: 15px 40px 35px 40px;
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .result {
        display: flex;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: rgba(18, 18, 18, 1);
        margin-left: 567px;
        p {
          color: #175dc2;
        }
      }
      .reset {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 114px;
        height: 39px;
        background: #ffffff;
        border: 1px solid #d3d3d3;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #121212;
        line-height: 20px;
        cursor: pointer;
        i {
          margin-right: 10px;
          line-height: 20px;
        }
      }
    }
    .table {
      //   width: 100%;
      table {
        width: 100%;
        border-collapse: collapse; /* 合并单元格边框 */
        border-spacing: 0; /* 移除单元格之间的间距 */
        margin: 15px 0 35px 0;
        th,
        td {
          /* 强制不换行 */
          white-space: nowrap;
          /* 内容超出容器隐藏 */
          overflow: hidden;
          /* 使用省略号表示被隐藏的内容 */
          text-overflow: ellipsis;
          /* 设置最大宽度或固定宽度 */
          width: 20%; /* 根据实际情况调整 */
          /* 确保内容不会自动扩展td的宽度 */
          display: inline-block;
          /* 可选：设定一个固定高度，如果适用 */
          height: 50px; /* 根据实际情况调整 */
          line-height: 50px;
        }
        thead {
          border-radius: 5px;
          background: #175dc2;

          tr {
            height: 50px;
            th {
              // width: 10%;
              font-family: PingFang SC, PingFang SC;

              font-weight: 600;
              font-size: 14px;
              color: #ffffff;
            }
          }
        }
        tbody {
          tr:nth-child(odd) {
          }
          tr:nth-child(even) {
            background: #f2f4fe;
            border-radius: 5px;
          }
          tr {
            td {
              // height: 50px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #121212;
              // white-space: nowrap; /* 禁止文字换行 */
              // overflow: hidden; /* 超出部分隐藏 */
              // text-overflow: ellipsis;
            }
          }
        }
      }
    }
    .paging {
      display: flex;
      justify-content: flex-end;
      padding-right: 45px;
    }
  }
}
</style>
